module.exports = __webpack_public_path__ + "media/images/smart_phone/login/202001/i_mob-56ee2b51bbab757c0597859fb94fbc63.png";